// IMPORTANT - This should stay in sync with the quivalent reducer in Sundae

import { SET_SHARED_VOUCHER_CODE } from '../actionTypes.constants'

const defaultState = {
  voucherCode: null,
}

const smartySharedData = (state = defaultState, action) => {
  switch (action.type) {
    case SET_SHARED_VOUCHER_CODE:
      return {
        ...state,
        voucherCode: action.voucherCode,
      }

    default:
      return state
  }
}

export default smartySharedData
